if (!customElements.get('collections-list-slider')) {
  class CollectionsListSlider extends HTMLElement {
    constructor() {
      super();
      this.mountSlider();
    }

    mountSlider() {
      this.slider = new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 8,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 22,
          }
        },
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        }
      });
    }
  }

  customElements.define('collections-list-slider', CollectionsListSlider);
}
